export const declinedApprovalDesignsApiPageSelector = (state, page) => {
  return state.api.designs.personal.approvals.declined.pages[page];
};

export const declinedApprovalDesignsApiSelector = (state, page) => {
  return state.api.designs.personal.approvals.declined;
};
